import { environment } from 'environments/environment';

export const OPERATOR_ORG_ID = 'o:11111111-1111-1111-1111-111111111111';
export const TENANT_ORG_ID = 'a:22222222-2222-2222-2222-222222222222';
export const ORG_API_BASE_ENDPOINT = `${environment.api_base}organisations`;
